import React from 'react';
import ReactDOM from 'react-dom';
import PrismicApp from './PrismicApp';
// import App from './components/App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';


ReactDOM.render(<PrismicApp />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js